import SectionHeading from "@/components/base/SectionHeading";
import { teamValues, crewPhotos } from "@/mocks/team";

export default function TeamSection() {
  return (
    <>
      {/* On the job */}
      <section className="bg-background-100 py-14 md:py-16">
        <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
          <SectionHeading
            eyebrow="On The Job"
            title="Our crews, straight from the field"
            subtitle="Real photographs of the Lahari crews who pack, load and deliver your belongings across Bangalore, Mysore and Tumkur."
          />
          <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {crewPhotos.map((photo) => (
              <figure
                key={photo.image}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <div className="aspect-[4/3] w-full overflow-hidden">
                  <img
                    src={photo.image}
                    alt={photo.title}
                    title={`${photo.title} - Lahari Packers and Movers`}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <figcaption className="p-5 md:p-6">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{photo.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{photo.caption}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* Culture */}
      <section className="bg-background-50 py-14 md:py-16">
        <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
          <SectionHeading eyebrow="How We Work" title="What every Lahari crew member stands for" />
          <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
            {teamValues.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-100 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}